<template>
  <v-tooltip left>
    <template #activator="{ on }">
      <span v-on="on">
        <v-btn
          :disabled="isToggleDisabled"
          :color="toggleColor"
          icon
          @click="switchUserState"
        >
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-btn>
      </span>
    </template>
    {{ tooltipText }}
  </v-tooltip>
</template>

<script>
import { wrapToLoadingFn } from '@helpers';

import UsersApiService from '../_services/users.api.service';

export default {
  name: 'UmsUserStateSwitcher',
  props: {
    state: Boolean,
    id: {
      type: [String, Number],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      const { state } = this;

      return state ? 'toggle_off' : 'toggle_on';
    },
    tooltipText() {
      const { state, type, name } = this;

      return type === 'AzureAdUser'
        ? 'To manage users of Azure AD, contact the system administrator'
        : `${state ? 'Disable' : 'Enable'} user ${name}`;
    },
    isToggleDisabled() {
      const { type } = this;

      return type === 'AzureAdUser';
    },
    toggleColor() {
      const { state } = this;

      return state ? 'success' : 'error';
    },
  },
  methods: {
    wrapToLoadingFn,
    switchUserState() {
      const { id, name, state } = this;

      this.$VBlackerTheme.alert.warning({
        text: `${state ? 'Disable' : 'Enable'} user ${name}`,
      }, () => this.wrapToLoadingFn({
        loadingSpinnerType: 'big',
        req: UsersApiService.changeUserLockedState.bind({}, { id, locked: state }),
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Users state successfully changed');
          this.$emit('success');
        },
      }));
    },
  },
};
</script>
